import gql from 'graphql-tag';

const UPDATE_LAST_CONNECTION = gql`mutation updateLastConnection ($input: LastConnectionInput) {
    updateLastConnection (input: $input) {
        internalCode
    }
}`;

export default UPDATE_LAST_CONNECTION;
